// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalConfirmation_wrapper__FYvcM","header":"ModalConfirmation_header__22OtJ","body":"ModalConfirmation_body__yHmIt","buttons":"ModalConfirmation_buttons__02V4Y"};